var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 6.5H6.4C5.6265 6.5 5 7.037 5 7.7V18.5L7.8 16.1H17.6C18.3735 16.1 19 15.563 19 14.9V7.7C19 7.037 18.3735 6.5 17.6 6.5Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.6e804e8c4da0b51abf5d8d40f684b3e4.svg";
export { ForwardRef as ReactComponent };